export default __webpack_public_path__ + "static/media/example-PopName.becac5c7.jpg";